import React from 'react';

import EditorDropDown from './ssEditorDropDown';
import RuntimeDropDown from './ssRuntimeDropDown';
import ViewOnlyDataSourceControl from '../ViewOnlyDataSourceControl';

const SSDropDown = (props) => {
  const { isEditor, isViewOnly, isDetail } = props;

  return isEditor && !isViewOnly ? (
    <EditorDropDown {...props} />
  ) : isViewOnly || isDetail ? (
    <ViewOnlyDataSourceControl {...props} />
  ) : (
    <RuntimeDropDown {...props} />
  );
};

export default SSDropDown;
